import React from 'react'
import { EarnProvider } from '~/lib/useEarns'
import { Outlet } from 'react-router-dom'
import { EarnType } from '~/lib/constants'

export const EarnPage: React.FC = () => <Outlet />

export const EarnRoute: React.FC<{ earnType: EarnType }> = ({ earnType }) => (
	<EarnProvider earnType={earnType} children={<EarnPage />} />
)
